"use client";

import { cn } from "@/lib";
import { CustomButton } from "../ui";
import Link from "next/link";
import AppContainer from "../appContainer";
import { useTranslations } from "next-intl";
import { routes } from "@/routes";

function HighlightSection() {
  const t = useTranslations();
  return (
    <section className={cn("relative z-10 mt-[-125px]")}>
      <AppContainer className="h-auto">
        <div className="mx-auto flex w-full flex-col gap-4 rounded-xl bg-white px-10 py-8 shadow sm:flex-row sm:gap-8 md:max-w-[700px] lg:max-w-[900px] xl:max-w-[1200px]">
          <div
            className={cn(
              "flex w-full flex-col items-center gap-2 sm:w-max sm:flex-row xl:gap-4",
            )}
          >
            <h3
              className={cn(
                "basis-1/4 flex-wrap text-center text-sm font-bold lg:text-base xl:text-lg",
              )}
            >
              {t("aboutUs.highlight.title")}
            </h3>
            <div
              className={cn(
                "bg-primary-main hidden h-[120%] w-[3px] rounded-lg sm:block",
              )}
            />
            <p
              className={cn(
                "text-custom-gray-200 flex w-full items-center justify-center p-4 text-center text-sm leading-5 sm:w-auto sm:basis-3/4 sm:text-justify lg:leading-[28px]! xl:text-base",
              )}
            >
              {t("aboutUs.highlight.description")}
            </p>
          </div>
          <div className={cn("flex items-center justify-center")}>
            <Link
              id="about-us-view-services"
              title={t("aboutUs.highlight.buttonText")}
              href={routes.main.SERVICES.primaryPath}
              target="_blank"
              rel="noopener"
              className="flex-center"
            >
              <CustomButton className="shadow-main w-max sm:h-9 sm:rounded-xl">
                {t("aboutUs.highlight.buttonText")}
              </CustomButton>
            </Link>
          </div>
        </div>
      </AppContainer>
    </section>
  );
}

export default HighlightSection;
